<template>
  <VModal
    title="Atualização dos Times do Cliente"
    description="Informe os times do cliente para que os processos sejam vinculados corretamente."
    :width="1200"
	:height="40"
    :handler="handler"
	classModify="remove-overflow"
    @requestClose="$emit('requestClose')"
  >
    <template #content>
      <CustomerTeamsForm
        v-if="formData"
        :key="formKey"
        ref="customerTeamsForm"
        :customer-details="formData"
        :show-loading="false"
      />
    </template>
    <template #footer>
      <div class="flex jc-c gap-2 p-3 fgap2">
        <button type="button" class="crm-button red mr-4" @click="$emit('requestClose')">
          Cancelar
        </button>
        <button type="submit" class="report-button" @click="save" :disabled="saving">
          Salvar
        </button>
      </div>
    </template>
  </VModal>
</template>

<script>
import Axios from "axios";
import Swal from "sweetalert2";
import config from "@/config.js";
import VModal from "@/components/VModal.vue";
import CustomerTeamsForm from "@/components/crm/CustomerTeamsForm.vue";

export default {
  name: "CustomerTeamsModal",
  components: {
    VModal,
    CustomerTeamsForm,
  },
  props: {
    handler: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: Number,
      default: null,
    },
    initialCustomer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: null,
      formKey: 0,
      saving: false,
    };
  },
  watch: {
    handler(isOpen) {
      if (isOpen) {
        this.formKey += 1;
        this.initFormData();
      }
    },
  },
  methods: {
    normalizeTeamField(value) {
      if (value && typeof value === "object" && value.id != null) {
        return value.id;
      }
      return value;
    },
    initFormData() {
      const source = this.initialCustomer || {};
      this.formData = {
        ...source,
        id: this.companyId || source.id,
        hasTypeAccountAndOrder: !!source.hasTypeAccountAndOrder,
        hasTypeOrder: !!source.hasTypeOrder,
        hasTypeAdvisory: !!source.hasTypeAdvisory,
        team: this.normalizeTeamField(source.team),
        teamOrder: this.normalizeTeamField(source.teamOrder),
        teamAdvisory: this.normalizeTeamField(source.teamAdvisory),
        customsTeam: this.normalizeTeamField(source.customsTeam),
      };
    },
    async save() {
      const form = this.$refs.customerTeamsForm;
      if (!form) {
        return;
      }

      if (form.validateProcessTeams()) {
        Swal.fire({
          title: "Tipos de Processo",
          html: "<p>Existem tipos de processo sem time vinculado!</p>",
          type: "warning",
        });
        return;
      }

      this.saving = true;
      this.$store.commit("setLoading", {
        show: true,
        label: "Aguarde...",
        description: "Salvando times do cliente.",
      });

      try {
        const response = await Axios.patch(
          `${config.env.API_DEFAULT.host}/company/${this.companyId}/teams-and-customs-teams`,
          form.buildPayload()
        );

        Swal.fire({
          title: "Times do cliente",
          text: response.data.message,
          type: "success",
        });

        this.$emit("saved", response.data.data);
        this.$emit("requestClose");
      } catch (e) {
        const message =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          "Erro ao salvar os times do cliente.";
        Swal.fire({
          title: "Times do cliente",
          text: message,
          type: "error",
        });
      } finally {
        this.saving = false;
        this.$store.commit("setLoading", { show: false });
      }
    },
  },
};
</script>


<style scoped>
.report-button {
  --webkit-appearance: none;
  --moz-appearance: none;
  outline: none;
  --webkit-outline: none;
  --moz-outline: none;
  border: 0;
  background-color: #104375;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border-radius: 2px;
  color: white;
  padding: 10px 35px;
  border-radius: 10px;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out 0s;
  font-size: 1rem;
}
</style>